import React from 'react';
import { ModalContent } from '../manage-tags/ModalContent';
import { ModalBodyText } from '../../StyledComponents/Typography';
import { useRoleAuthorization } from '../../hooks/RoleAuthorization';
import { StyledModal } from '../StyledModal';
import { useMutation } from '@tanstack/react-query';
import { promoteRelease, Release } from '../../services/ReleaseService';

interface PromoteModalProps {
  release: Release;
  isVisible: boolean;
  onClose: () => void;
  refetch: () => void;
}

export const PromoteModal = (props: PromoteModalProps) => {
  const { isVisible, onClose, refetch, release } = props;

  const handleClose = () => {
    refetch();
    onClose();
  };

  const {
    mutate,
    isPending: loading,
    error,
  } = useMutation({
    mutationFn: promoteRelease,
    onSuccess: () => handleClose(),
  });
  const { getPromotionTarget } = useRoleAuthorization();

  const onPromoteConfirm = async () => {
    if (!release || !release.id) {
      return;
    }
    mutate(release.id);
  };

  return (
    <StyledModal
      isOpen={isVisible}
      onRequestClose={handleClose}
      label="promote-modal"
    >
      <ModalContent
        title={`Promote OTA Release ${release?.semver}`}
        loading={loading}
        error={error}
        handleSubmit={onPromoteConfirm}
        submitDisabled={loading}
        handleClose={handleClose}
        buttonLabels={{ loading: 'Promoting Release...', create: 'Promote' }}
      >
        <ModalBodyText>New Environment</ModalBodyText>
        <ModalBodyText bold={true}>{getPromotionTarget() || ''}</ModalBodyText>
      </ModalContent>
    </StyledModal>
  );
};
